export const CUSTOM_AUTH_TOKEN_PARAM = "authToken"
export const CUSTOM_BILLING_PERIOD_PARAM = "redirectToCheckout"
